var Request = require('../helper/request');
var Feed = require('./feed');
var BranchAssignment = require('./branchAssignment');
var ModuleAssignment = require('./moduleAssignment');
var Tag = require('./tag');
var Hashtag = require('./hashtag');
var User = require('./user');
var Register = require('./register');
var Search = require('./search');
var Setting = require('./setting');
var UserSpecification = require('./userSpecification');
var UserSpecificationGroup = require('./userSpecificationGroup');
var Branch = require("./branch");
var Popular = require("./popular");
var Advertisement = require("./advertisement");
var Feedback = require("./feedback");
var Notification = require("./notification");
var Statistic = require("./statistic");
var Info = require("./info");
var Invite = require("./invite");
var Term = require("./term");
var TagAssignment = require("./tagAssignment");
var Menu = require("./menu");

function Company(app){
  var self = this;
  self.request = new Request(app);
  self.app = app;

  self.routes = {
    index: {
      url: '/company',
      method: 'GET'
    },
    show: {
      url: '/company/:id',
      method: 'GET'
    },
    create: {
      url: '/company',
      method: 'POST'
    },
    update: {
      url: '/company/:id',
      method: 'PUT'
    },
    delete: {
      url: '/company/:id',
      method: 'DELETE'
    }
  };
}

Company.prototype.index = function(){
  var self = this;
  return self.request.get(self.routes.index.url);
}

Company.prototype.show = function(id){
  var self = this;
  var uri = self.routes.show.url.replace(':id', id);
  return self.request.get(uri);
}

Company.prototype.create = function(data){
  var self = this;
  return self.request.post(self.routes.create.url, {
    company: data
  });
}

Company.prototype.update = function(id, data){
  var self = this;
  var uri = self.routes.update.url.replace(':id', id);
  return self.request.put(uri, {
    company: data
  });
}

Company.prototype.delete = function(id){
  var self = this;
  var uri = self.routes.delete.url.replace(':id', id);
  return self.request.delete(uri)
}

Company.prototype.feed = function(companyId){
  var self = this;
  return new Feed(self.app, companyId);
}

Company.prototype.branchAssignment = function(companyId){
  var self = this;
  return new BranchAssignment(self.app, companyId);
}

Company.prototype.moduleAssignment = function(companyId){
  var self = this;
  return new ModuleAssignment(self.app, companyId);
}

Company.prototype.tag = function(companyId){
  var self = this;
  return new Tag(self.app, companyId);
}

Company.prototype.hashtag = function(companyId){
  var self = this;
  return new Hashtag(self.app, companyId);
}

Company.prototype.user = function(companyId){
  var self = this;
  return new User(self.app, companyId);
}

Company.prototype.register = function(companyId){
  var self = this;
  return new Register(self.app, companyId);
}

Company.prototype.search = function(companyId){
  var self = this;
  return new Search(self.app, companyId);
}

Company.prototype.setting = function(companyId){
  var self = this;
  return new Setting(self.app, companyId);
}

Company.prototype.userSpecification = function(companyId){
  var self = this;
  return new UserSpecification(self.app, companyId);
}

Company.prototype.userSpecificationGroup = function(companyId){
  var self = this;
  return new UserSpecificationGroup(self.app, companyId);
}

Company.prototype.info = function(companyId){
  var self = this;
  return new Info(self.app, companyId);
}

Company.prototype.branch = function(companyId){
  var self = this;
  return new Branch(self.app, companyId);
};

Company.prototype.popular = function(companyId){
  var self = this;
  return new Popular(self.app, companyId);
};

Company.prototype.advertisement = function(companyId){
  var self = this;
  return new Advertisement(self.app, companyId);
}

Company.prototype.feedback = function(companyId){
  var self = this;
  return new Feedback(self.app, companyId);
}

Company.prototype.notification = function(companyId){
  var self = this;
  return new Notification(self.app, companyId);
}

Company.prototype.statistic = function(companyId){
  var self = this;
  return new Statistic(self.app, companyId);
}

Company.prototype.invite = function(companyId){
  var self = this;
  return new Invite(self.app, companyId);
}

Company.prototype.term = function(companyId){
  var self = this;
  return new Term(self.app, companyId);
}

Company.prototype.tagAssignment = function(companyId) {
  var self = this;
  return new TagAssignment(self.app, companyId)
}

Company.prototype.menu = function(companyId) {
  var self = this;
  return new Menu(self.app, companyId)
}

module.exports = Company;
